module.exports = __webpack_public_path__ + "img/OperationaTitle.26fda542.png";